import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';
import { BoxProps } from '@mui/material/Box';
import { ReactNode, useContext } from 'react';
import { SidebarContext } from '@/common/components/sidebar/SidebarContext.ts';
import { SidebarHeader } from '@/common/components/sidebar/subcomponents/sidebar-header/SidebarHeader.tsx';
import { SidebarContent } from '@/common/components/sidebar/subcomponents/sidebar-content/SidebarContent.tsx';

export interface SidebarProps {
  backgroundColor?: string;
  width: BoxProps['width'];
  children?: ReactNode;
}

export const Sidebar = ({ backgroundColor, width, children }: SidebarProps) => {
  const { isOpen, onClose, id } = useContext(SidebarContext);
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      sx={{ zIndex: theme.zIndex.appBar + 100 }}
      slotProps={{
        paper: {
          sx: { width, backgroundColor: backgroundColor ?? theme.palette.background.default },
          'aria-labelledby': `sidebar-title-${id}`,
        },
      }}
    >
      {children}
    </Drawer>
  );
};

Sidebar.Header = SidebarHeader;
Sidebar.Content = SidebarContent;
